import { Sparklines, SparklinesLine } from "react-sparklines";

export const renderSparklines = (
	ticker: string,
	data: Record<string, { field: number[] }>,
) => {
	if (!data[ticker]) return null;

	const { field } = data[ticker];
	if (!field?.length) return null;

	const lastValue = field[field.length - 1];
	const firstValue = field[0];

	const color =
		lastValue >= firstValue ? "var(--success-light)" : "var(--error-light)";

	return (
		<Sparklines data={field} height={20} style={{ width: "100%" }}>
			<SparklinesLine color={color} style={{ fillOpacity: 0.7 }} />
		</Sparklines>
	);
};
